import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ADMINMODE } from "../tools/url";
import { useEffect, useState } from "react";
import UnderMaintenance from "../pages/underMaintenance";
import ForbiddenPage from "./errors/ForbiddenPage";

function PrivateRoute({ Component, props }) {
    const { user, isAdmin, loading, profileComplete, isContentProvider, serverHealthy, onboardingCompleted } = useAuth();
    const navigate = useNavigate();

    const [canRender, setCanRender] = useState(null);
    // The route exists but this account may not open it (a learner on a composer/admin URL).
    // Rendered in place as a 403, not a blank screen.
    const [forbidden, setForbidden] = useState(false);

    useEffect(() => {
        setForbidden(false);
        if (loading) setCanRender(false);
        else if (!serverHealthy) {
            setCanRender(false);
            return <UnderMaintenance />
        } else if (user) { // check if user is logged in
            // GATE 1: Onboarding must be completed for all users
            if (!onboardingCompleted && !props?.onboarding) {
                setCanRender(false);
                navigate("/onboarding");
                return;
            }
            if (!isAdmin && ADMINMODE) { // check if arrows is only available to admins
                setCanRender(false);
                return <UnderMaintenance />
            } else if (!isAdmin && isContentProvider && props?.contentProvider) { // this specific component is an content provider-only component
                setCanRender(true);
            } else if (!isAdmin && props?.admin) { // this specific component is an admin-only component
                setCanRender(false);
                setForbidden(true);
            } else if (onboardingCompleted && !profileComplete && !props?.newUserForm) { // user didn't complete required profile fields
                setCanRender(false);
                navigate("/newuser");
            } else {
                setCanRender(true);
            }
        } else {
            setCanRender(false);
            if (user === null) navigate("/login"); // checked and there is no user
        }
    }, [user, isAdmin, loading, profileComplete, props, serverHealthy, onboardingCompleted, isContentProvider, navigate]);

    if (canRender) return <Component props={props} />;
    return forbidden ? <ForbiddenPage /> : null;
}

export default PrivateRoute;
